import React, { useState } from "react";

import VideoCard from "../../components/cards/videoCard";
import MyGallery from "../../components/myGallery";
import Modal from "../../components/shared/modal";
import Portal from "../../components/shared/portal";
import EyeSVG from "../../images/icons/view-more-icon.inline.svg";

const GalleryBtnWithModal = ({
  featVideo,
  galleryPhotos,
  btnLabel = "See gallery",
  programFeaturedVideoTestimonials = [],
  extraButtonClass = ""
}) => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      <button
        className={`callback-button flex py-2 px-2 sm:px-3 mx-auto justify-between items-center bg-white planet:bg-transparent sm:gvi-blur-bg !text-base sm:text-white sm:border sm:border-white sm:rounded-full planet:sm:rounded-sm planet:hover:!bg-primary-bg ${extraButtonClass}`}
        onClick={() => setOpenModal(true)}
      >
        <p className="text-mob sm:text-base font-bold sm:font-normal m-auto sm:m-0 text-black-lighter planet:text-white sm:text-white !p-0">
          {btnLabel}
        </p>

        <span className="items-center hidden pl-2 sm:flex">
          <EyeSVG className="object-contain object-center view-more fill-white" />
        </span>
      </button>

      {openModal && (
        <Portal>
          <Modal
            closeModal={() => setOpenModal(false)}
            modalCloseBtnStyles="hidden"
            modalContainerStyles="w-full h-full"
            modalContentStyles="w-full h-full mx-auto planet:gvi-dark-gray-bg bg-primary-bg py-3 relative"
            modalContent={
              <>
                <div
                  onClick={() => setOpenModal(false)}
                  className="bg-transparent absolute w-full h-full top-0 bottom-0 right-0 left-0"
                />
                <div className="p-0 w-10/12 sm:px-0 sm:w-9/12 m-auto h-full overflow-scroll relative">
                  <div className="mb-5">
                    <div
                      onClick={() => setOpenModal(false)}
                      className="general-link"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M10 19l-7-7m0 0l7-7m-7 7h18"
                        />
                      </svg>
                    </div>
                  </div>

                  {featVideo && (
                    <div
                      className="project-video featured-video-base-gallery bg-white text-white col-span-2 row-span-2 rounded-sm sm:min-h-96 h-auto relative"
                      dangerouslySetInnerHTML={{ __html: featVideo }}
                    />
                  )}

                  {programFeaturedVideoTestimonials &&
                    programFeaturedVideoTestimonials?.length > 0 && (
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-3 mt-2 mb-1">
                        {programFeaturedVideoTestimonials.map(
                          (videoUrl, idx) => {
                            const useVideo =
                              videoUrl.programFeaturedVideo ??
                              videoUrl?.genVideoUrl;
                            return (
                              <div
                                key={`feat-video-item-${idx}`}
                                className={`${
                                  programFeaturedVideoTestimonials?.length %
                                    2 !==
                                    0 &&
                                  programFeaturedVideoTestimonials?.length ===
                                    idx + 1
                                    ? " col-span-full "
                                    : ""
                                } `}
                              >
                                <VideoCard
                                  key={idx}
                                  featVideos={useVideo}
                                  cardClass={`${idx === 0 ? "mr-1 sm:mr-0" : ""} ${
                                    idx === 1 ? "ml-1 sm:ml-0" : ""
                                  } h-auto sm:h-full bg-cover bg-no-repeat bg-center`}
                                />
                              </div>
                            );
                          }
                        )}
                      </div>
                    )}

                  <MyGallery
                    allWpMediaItem={galleryPhotos}
                    galleryOuterClass="w-full my-1"
                  />
                </div>
              </>
            }
          />
        </Portal>
      )}
    </>
  );
};

export default GalleryBtnWithModal;
